export function segmentToSlug(segment: string): string {
  const slug = segment.trim().toLowerCase().replace(/[\s_]+/g, "-");
  return encodeURIComponent(slug);
}

export function buildRouteFromPath(segments: string[]): string {
  if (segments.length === 0) {
    return "/";
  }

  return `/${segments.map(segmentToSlug).join("/")}`;
}

export function normalizePathKey(...segments: string[]): string {
  return segments
    .filter(Boolean)
    .map((segment) => segment.trim().toLowerCase().replace(/[\s_]+/g, "_"))
    .join("_");
}

export function routeToMetadataKey(route: string): string {
  return route
    .split("/")
    .filter(Boolean)
    .map((segment) => decodeURIComponent(segment).replace(/-/g, "_"))
    .join("_");
}

export function isRouteActive(pathname: string, route: string): boolean {
  return pathname === route;
}
